import { ReactElement } from 'react';
import { ItemLoader, UpdateContainer, useEntity } from 'components';
import { platformAdmin, useHasPerm } from 'core/permissions';
import type { AgencySequences } from 'modules/core/types';
import { SequencesFields } from './Fields';

export function Sequences(): ReactElement {
  const { endpoint } = useEntity();
  const canEdit = useHasPerm(platformAdmin);
  const url = `${endpoint}sequences/`;

  return (
    <ItemLoader<AgencySequences> url={url}>
      {({ item, setItem }) => (
        <UpdateContainer
          url={url}
          initialValues={item}
          updateItem={setItem}
          method="POST"
          breadcrumb="Sequences"
          disabled={!canEdit}
        >
          <div className="container px-0 ml-0">
            <SequencesFields disabled={!canEdit} />
          </div>
        </UpdateContainer>
      )}
    </ItemLoader>
  );
}
